import React, { Fragment } from 'react';
import TermsOfServiceComponent from '../components/terms_of_service/terms_of_service_component';
import PageHelmet from '../components/common/PageHelmet';

export default function TermsOfServiceScreen() {
    return (
        <Fragment>
            <PageHelmet 
                title="Terms of Service - Rubaai Digital Payment Solutions"
                description="Read Rubaai's Terms of Service to understand the terms and conditions for using our digital payment platforms, POS systems, and employee management solutions."
                keywords="terms of service, terms and conditions, user agreement, Rubaai terms, service agreement, legal terms"
            />
            <TermsOfServiceComponent />
        </Fragment>
    );
}